import { createLookup } from '../store/createLookup'

export const CURRENCIES_LIST = [
  {
    id: 'AUD',
    label: 'AUD - Australian dollar'
  },
  {
    id: 'USD',
    label: 'USD - U.S dollar'
  },
  {
    id: 'GPB',
    label: 'GPB - Great Britain pound (sterling)'
  }
]

export const getCurrencyType = createLookup(CURRENCIES_LIST, 'currency types')
export const DEFAULT_CURRENCY_TYPE = getCurrencyType('AUD')
